// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/model/track.proto (package knop.ui.v1.model, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Point } from "./point_pb.js";

/**
 * @generated from message knop.ui.v1.model.Track
 */
export class Track extends Message<Track> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: uint32 length_in_mm = 3;
   */
  lengthInMm = 0;

  constructor(data?: PartialMessage<Track>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.Track";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "length_in_mm", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Track {
    return new Track().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Track {
    return new Track().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Track {
    return new Track().fromJsonString(jsonString, options);
  }

  static equals(a: Track | PlainMessage<Track> | undefined, b: Track | PlainMessage<Track> | undefined): boolean {
    return proto3.util.equals(Track, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.model.TrackWithGeometry
 */
export class TrackWithGeometry extends Message<TrackWithGeometry> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: uint32 length_in_mm = 3;
   */
  lengthInMm = 0;

  /**
   * @generated from field: string from_code = 4;
   */
  fromCode = "";

  /**
   * @generated from field: string to_code = 5;
   */
  toCode = "";

  /**
   * @generated from field: repeated knop.ui.v1.model.Point coordinates_from_source_to_target = 6;
   */
  coordinatesFromSourceToTarget: Point[] = [];

  constructor(data?: PartialMessage<TrackWithGeometry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.TrackWithGeometry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "length_in_mm", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "from_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "to_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "coordinates_from_source_to_target", kind: "message", T: Point, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TrackWithGeometry {
    return new TrackWithGeometry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TrackWithGeometry {
    return new TrackWithGeometry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TrackWithGeometry {
    return new TrackWithGeometry().fromJsonString(jsonString, options);
  }

  static equals(a: TrackWithGeometry | PlainMessage<TrackWithGeometry> | undefined, b: TrackWithGeometry | PlainMessage<TrackWithGeometry> | undefined): boolean {
    return proto3.util.equals(TrackWithGeometry, a, b);
  }
}

